import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { ReactComponent as DangerSvg } from 'static/svg/exclamation-icon-variant.svg'

import * as S from './styles'

interface ErrorModalProps {
  onClose: () => void
  patientName: string
  planName: string
  scheduleCount: number
}

export function ErrorModal({
  onClose,
  patientName,
  planName,
  scheduleCount,
}: ErrorModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle={
        <S.TitleContainer>
          <DangerSvg  width={50} height={50} />
          <Typography
            center
            weight='bold'
            variant='content1'
          >
            Não foi possível publicar o formulário!
          </Typography>
        </S.TitleContainer>
      }
      btnText='Tentar novamente'
      hasButton
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <S.ErrorModalContainer>
        <Typography
          variant='content2'
          center
        >
          {patientName}
        </Typography>
        {scheduleCount && (
          <Typography
            variant='content2'
            weight='bold'
            center
          >
            {scheduleCount}ª consulta realizada
          </Typography>
        )}
        <Typography
          variant='content2'
          center
        >
          {planName}
        </Typography>
      </S.ErrorModalContainer>
    </ModalGeneric>
  )
}
